import React, { PureComponent } from 'react';
import cn from 'classnames';
import FontIcon from '../FontIcons/FontIcon';

export default class Chip extends PureComponent {
    static defaultProps = {
        rotateIcon: true,
        children: <FontIcon>add_circle</FontIcon>,
    };

    state = { hover: false };

    _handleMouseEnter = (e) => {
        if (this.props.onMouseEnter) {
            this.props.onMouseEnter(e);
        }

        this.setState({ hover: true });
    };

    _handleMouseLeave = (e) => {
        if (this.props.onMouseLeave) {
            this.props.onMouseLeave(e);
        }

        this.setState({ hover: false });
    };

    render() {
        const { hover } = this.state;
        const {
            label,
            className,
            labelStyle,
            labelClassName,
            avatar,
            children,
            removable,
            remove,
            onClick,
            rotateIcon,

            /* eslint-disable no-unused-vars */
            // deprecated
            iconClassName,
            removeIconChildren,
            removeIconClassName,
            /* eslint-enable no-unused-vars */
            ...props
        } = this.props;

        let icon;
        if (removable || remove) {
            const chipIconCN = cn('md-chip-icon', {
                'md-chip-icon--rotate': rotateIcon,
                'md-chip-text--hover': hover,
            });

            if (React.isValidElement(children)) {
                icon = React.Children.only(children);
                icon = React.cloneElement(icon, { className: cn(chipIconCN, icon.props.className) });
            } else {
                icon = (
                    <FontIcon className={chipIconCN} iconClassName={iconClassName}>
                        {children}
                    </FontIcon>
                );
            }
        }

        return (
            <button
                type="button"
                {...props}
                className={cn('md-chip', {
                    'md-chip--avatar': avatar,
                    'md-chip--remove': removable,
                    'md-chip--hover': hover,
                }, className)}
                onClick={remove || onClick}
                onMouseEnter={this._handleMouseEnter}
                onMouseLeave={this._handleMouseLeave}
            >
                {avatar}
                <span
                    style={labelStyle}
                    className={cn('md-chip-text', {
                        'md-chip-text--hover': hover,
                    }, labelClassName)}
                >
                    {label}
                </span>
                {icon}
            </button>
        );
    }
}
